import React, { Fragment, useEffect, useState } from "react";
import { ProfileSetupStepper } from "./ProfileSetupStepper";
import { Box, Dialog, Stack, Typography } from "@mui/material";
import { GenericIconButton } from "../../generic/GenericIconButton";
import { X } from "@phosphor-icons/react";
import { BasicInformationForm } from "./basicInformation/BasicInformationForm";
import { createOrUpdateUserDetails, getUserDetails } from "../../../config/apisauce";
import { BASIC_INFO_KEY, BIO_KEY, LINKS_KEY, ONDATO_APPROVAL, VERIFY_FACE_ID_KEY } from "../../../enums/profileSetupEnums";
import { LinksForm } from "./links/LinksForm";
import { BioForm } from "./bio/BioForm";
import { ContactInformationForm } from "./contactInformation/ContactInformationForm";
import { VerifyFaceAndIdForm } from "./verify/VerifyFaceAndIdForm";
import { OndatoVerification } from "./verify/OndatoVerification";

export const ProfileSetupDialog = (props) => {
  const {
    openProfileSetupDialog,
    handleCloseProfileSetupDialog,
    selectedSetupForm,
    userDetails,
    setSelectedSetupForm,
  } = props;

  const [isOndatoApproval, setIsOndatoApproval] = useState(false);
  const [initialUserDetail, setInitialUserDetails] = useState({});

  const fetchUserDetails = async () => {
    const { ok, data } = await getUserDetails({ user_id: userDetails?.id });
    if (ok) {
      setInitialUserDetails(data);
      setSelectedSetupForm(data?.current_step);
    }
  };

  const handleSubmit = async (values, nextForm) => {
    const isFinalStep = nextForm === ONDATO_APPROVAL;
    const params = {
      ...values,
      user_id: userDetails?.id,
      current_step: isFinalStep ? VERIFY_FACE_ID_KEY : nextForm
    };
    const response = await createOrUpdateUserDetails(params);
    if (response.ok) {
      if (!isFinalStep) {
        setSelectedSetupForm(nextForm);
      } else {
        setIsOndatoApproval(true);
      }
      fetchUserDetails();
    }
  };

  const handleCloseDialog = () => {
    handleCloseProfileSetupDialog();
    setIsOndatoApproval(false);
  };

  const handleChangeForm = (form) => {
    setSelectedSetupForm(form);
  };

  useEffect(() => {
    setSelectedSetupForm(BASIC_INFO_KEY);
    if (openProfileSetupDialog) fetchUserDetails();
  }, [openProfileSetupDialog]);

  const genericFormProps = {
    selectedSetupForm: selectedSetupForm,
    initialUserDetail: initialUserDetail,
    handleChangeForm: handleChangeForm,
    handleSubmit: handleSubmit,
  };

  const forms = {
    [BASIC_INFO_KEY]: <BasicInformationForm handleCloseDialog={handleCloseDialog} {...genericFormProps} />,
    [LINKS_KEY]: <LinksForm fetchUserDetails={() => fetchUserDetails()} {...genericFormProps} />,
    [BIO_KEY]: <BioForm {...genericFormProps} />,
    // [CONTACT_INFO_KEY]: <ContactInformationForm {...genericFormProps} />,
    [VERIFY_FACE_ID_KEY]: <VerifyFaceAndIdForm {...genericFormProps} />
  };

  return (
    <Fragment>
      <Dialog
        open={openProfileSetupDialog}
        sx={{
          '.MuiDialog-paper': {
            padding: '0px 13px',
            width: isOndatoApproval ? '555px' : '854px',
          },
          '& .MuiBackdrop-root': {
            backgroundColor: 'rgba(0, 0, 0, 0.7)',
            backdropFilter: 'blur(2px)'
          },
        }}
      >
        {
          isOndatoApproval ? <OndatoVerification handleCloseDialog={handleCloseDialog} /> : <Fragment>
            <Stack direction={'row'} justifyContent={'space-between'} alignItems={'center'} mb={2} sx={{ padding: '32px 10px 0px 10px' }}>
              <Typography variant="h5" color="primary" fontWeight={700} textAlign={'center'}>Profile Setup</Typography>
              <GenericIconButton
                tooltip={'Close'}
                icon={<X size={24} />}
                onClick={() => handleCloseDialog()}
              />
            </Stack>
            <ProfileSetupStepper selectedSetupForm={selectedSetupForm} />
            <Box sx={{ padding: '30px 10px 32px 10px', }}>
              <Box sx={{ overflowX: 'auto', height: { xs: '50vh', sm: '100%' } }}>
                {selectedSetupForm ? forms?.[selectedSetupForm] : forms?.[BASIC_INFO_KEY]}
              </Box>
            </Box>
          </Fragment>
        }
      </Dialog >
    </Fragment>
  );
};